// StatsAction.js
import { userService } from "../services";
import config from "../config/config";

export const StatsAction = {
  fetchDashboardData,
  fetchAlertsData,
  fetchStatDashboardParkingData,
  fetchweekWiseComparisonGraphData,
  fetchDriverDashboardData,
  fetchDocumentExpiryReport,
  fetchDocumentExpiryDashboard,
  fetchOverUtilizedLocksData,
  fetchUnderUtilizedLocksData,
  fetchFuelUtilizationDashboardData,
  fetchFuelVehicleStatusData,
  getDriversScoreCard,
  getDriversScoreCardDistanceEvents,
  getDriversSafetySummary,
  getDriversSafetyTrend,
  fetchFuelDashboardTrendData,
  fetchSecureVehicles,
  fetchTopDroppageVehicles,

};

function mapFuelDashboardResponse(raw) {
  if (!raw) return null;
  return {
    fmsEnabledVehicles: raw.coverage?.fmsEnabled ?? 0,
    totalFleet: raw.coverage?.totalFleet ?? 0,
    coveragePercent: raw.coverage?.pct ?? 0,
    alerts: {
      vtsSos: raw.alerts?.sos ?? 0,
      tampering: raw.alerts?.tampering ?? 0,
      fuelDrop: {
        count: raw.alerts?.fuelDrop?.total ?? 0,
        confirmed: raw.alerts?.fuelDrop?.confirmed ?? 0,
        unchecked: raw.alerts?.fuelDrop?.unchecked ?? 0,
      },
      fuelFill: {
        count: raw.alerts?.fuelFill?.total ?? 0,
        confirmed: raw.alerts?.fuelFill?.confirmed ?? 0,
        unchecked: raw.alerts?.fuelFill?.unchecked ?? 0,
      },
    },
    consumption: {
      expected: raw.consumption?.expectedL ?? 0,
      actual: raw.consumption?.actualL ?? 0,
      deviation: raw.consumption?.deviationL ?? 0,
    },
    droppage: {
      confirmed: raw.droppage?.confirmedL ?? 0,
      unchecked: raw.droppage?.uncheckedL ?? 0,
      estimatedFinancialLoss: raw.droppage?.estimatedLoss ?? 0,
      dieselPrice: raw.droppage?.dieselPrice ?? 0,
    },
    refill: {
      confirmedFills: raw.refill?.confirmedL ?? 0,
      uncheckedFills: raw.refill?.uncheckedL ?? 0,
      totalFillsRegistered: raw.refill?.totalL ?? 0,
    },
    // distanceVsFuel intentionally NOT included here — this endpoint
    // doesn't return it, so leaving the key out lets the component's
    // `{ ...DEFAULT_FUEL_DATA, ...data }` spread fall back to the
    // static sample chart data automatically.
  };
}

function mapFuelTrendResponse(raw) {
  if (!Array.isArray(raw)) return null;
  return raw.map((row) => ({
    date: new Date(row.date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    }), // "2026-09-10T..." → "10 Sep"
    distance: row.distanceKm ?? 0,
    fuel: row.fuelL ?? 0,
  }));
}

async function fetchDashboardData(payload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;
  const userType = localData?.userType;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.statsDashboardUrl
      }?userId=${userId}&companyId=${companyId}&isParked=true&userType=${userType}&kycStatusEnum=`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchAlertsData(payload) {
  try {
    const configData = JSON.parse(localStorage.getItem("config"));
    const notificationUrl = JSON.parse(configData.datas)?.notificationBaseUrl;
    const apiEndPoint = `${notificationUrl}${config.apiName.statsDashboardAlertsUrl}`;

    const updatedPayload = {
      ...payload,
      startDate: payload.startDate
        ? new Date(payload.startDate).toISOString()
        : null,
      endDate: payload.endDate ? new Date(payload.endDate).toISOString() : null,
    };

    const response = await userService.post(apiEndPoint, updatedPayload);

    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else if (response && response.status === 208) {
      return response;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchStatDashboardParkingData(payload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;
  const userType = localData?.userType;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.statsDashboardParkingData
      }?userId=${userId}&companyId=${companyId}&userType=${userType}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchweekWiseComparisonGraphData(payload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;
  const userType = localData?.userType;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.weekWiseComparisonGraphData
      }?userId=${userId}&companyId=${companyId}&userType=${userType}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
  }
}

async function fetchDriverDashboardData() {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const companyId = localData?.companyId;
  try {
    // Get base URL from config
    const baseUrl = getDriverServiceBaseUrl();
    console.log("sdjkbskjdhskjhsd", baseUrl);
    // Construct URL with proper path
    const apiEndPoint = `${baseUrl}${config.apiName.driverDashboard}?companyId=${companyId}`;
    console.log("sdjkbskjdhskjhsd-1", apiEndPoint);

    const response = await userService.get(apiEndPoint);
    console.log("sdjkbskjdhskjhsd-3", response);
    if (response && response.status === 200) {
      return response.data?.data ?? null;
    }
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchDocumentExpiryReport({ daysWindow } = {}) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const companyId = localData?.companyId;
  try {
    // Get base URL from config
    const baseUrl = getDriverServiceBaseUrl();

    const params = new URLSearchParams({ companyId });
    if (daysWindow !== undefined) params.append("daysWindow", daysWindow);
    const apiEndPoint = `${baseUrl}${config.apiName.driverDocumentExpiryReport}?${params.toString()}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data?.data ?? null;
    }
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchDocumentExpiryDashboard() {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const companyId = localData?.companyId;
  try {
    // Get base URL from config for vehicle documents
    const baseUrl = getVehicleDocumentServiceBaseUrl();
    const apiEndPoint = `${baseUrl}/${config.apiName.vehicleDocumentDashboard}?companyId=${companyId}`;
    const response = await userService.get(apiEndPoint);

    if (
      response &&
      response.status === 200 &&
      response.data?.responseCode === 200
    ) {
      return response.data?.data || null;
    }
    return null;
  } catch (err) {
    console.error("Error fetching document expiry dashboard:", err);
    return null;
  }
}

// Helper function to get driver service base URL
function getDriverServiceBaseUrl() {
  try {
    // Try to get from localStorage first (if dynamically set)
    const configData = JSON.parse(localStorage.getItem("config"));
    const datas = JSON.parse(configData?.datas || "{}");

    if (datas?.driverServiceUrl) {
      return datas.driverServiceUrl;
    }
  } catch { }
}

// Helper function to get vehicle document service base URL
function getVehicleDocumentServiceBaseUrl() {
  try {
    // Try to get from localStorage first (if dynamically set)
    const configData = JSON.parse(localStorage.getItem("config"));
    const datas = JSON.parse(configData?.datas || "{}");

    if (datas?.driverServiceUrl) {
      return datas.driverServiceUrl;
    }
  } catch {
    // return config.vehicleDocumentServiceBaseUrl || config.driverServiceBaseUrl || "http://localhost:8090";
  }
}

async function fetchOverUtilizedLocksData(payload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.overUtilizedLocksData
      }?userId=${userId}&noOfDays=${payload?.noOfDays}&tripType=${payload?.tripType}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchUnderUtilizedLocksData(payload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.underUtilizedLocksData
      }?userId=${userId}&noOfDays=${payload?.noOfDays}&tripType=${payload?.tripType}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchFuelUtilizationDashboardData() {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.fuelUtilizationDashboard}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return mapFuelDashboardResponse(response.data); // ← raw body, no .data.data
    }
    return null;
  } catch (err) {
    console.log(
      "fuel utilization dashboard fetch failed, using static fallback",
      err,
    );
    return null;
  }
}

async function getDriversScoreCard() {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;
  try {
    const apiEndPoint = `${getDriverServiceBaseUrl()}${config.apiName.getDriversScoreCard
      }?createdBy=${userId}&companyId=${companyId}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
  }
}
async function fetchFuelDashboardTrendData(days = 7) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.fuelDashboardTrend}?days=${days}`;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return mapFuelTrendResponse(response.data);
    }
    return null;
  } catch (err) {
    console.log("fuel trend fetch failed, using static fallback", err);
    return null;
  }
}

async function getDriversScoreCardDistanceEvents(rawPayload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;

  const payload = {
    companyId,
    createdBy: userId,
    days: rawPayload?.days,
  };
  try {
    let url = `${getDriverServiceBaseUrl()}${config.apiName.getDriversScoreCardDistanceEvents}`;
    const apiEndPoint = buildUrl(url, payload);
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function getDriversSafetySummary(rawPayload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;

  const payload = {
    companyId,
    createdBy: userId,
    days: rawPayload?.days,
  };
  try {
    let url = `${getDriverServiceBaseUrl()}${config.apiName.getDriversSafetySummary}`;
    const apiEndPoint = buildUrl(url, payload);
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function getDriversSafetyTrend(rawPayload) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  const companyId = localData?.companyId;

  const payload = {
    companyId,
    createdBy: userId,
    days: rawPayload?.days,
  };
  try {
    let url = `${getDriverServiceBaseUrl()}${config.apiName.getDriversSafetyTrend}`;
    const apiEndPoint = buildUrl(url, payload);
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}

async function fetchTopDroppageVehicles(days = 7) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.topDroppageVehicles}?days=${days}`;
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      const vehicleMap = await getVehicleLookupMap(); // id -> { vehicleNo, type }
      return mapTopDroppageResponse(response.data, vehicleMap);
    }
    return null;
  } catch (err) {
    console.log("top droppage fetch failed, using static fallback", err);
    return null;
  }
}

async function fetchSecureVehicles(days = 7) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.secureVehicles}?days=${days}`;
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return mapSecureVehiclesResponse(response.data);
    }
    return null;
  } catch (err) {
    console.log("secure vehicles fetch failed, using static fallback", err);
    return null;
  }
}

async function fetchFuelVehicleStatusData(cursor = null) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const companyId = localData?.companyId;
  try {
    const base = JSON.parse(localStorage.getItem("config")).baseUrl + config.apiName.fuelVehicleStatusDashboard;
    const apiEndPoint = cursor ? `${base}?cursor=${cursor}` : base;

    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200) {
      return mapFuelVehicleStatusResponse(response.data);
    }
    return null;
  } catch (err) {
    console.log("fuel vehicle status fetch failed, using static fallback", err);
    return null;
  }
}

const STATUS_TITLE_CASE = {
  STOPPED: "Stopped",
  IDLE: "Idle",
  RUNNING: "Running",
  OFFLINE: "Offline",
};

const formatEngineHours = (ms) => {
  if (ms == null) return "—";
  const totalMinutes = Math.floor(ms / 60000);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

const formatLastUpdated = (ts) => {
  if (ts == null) return "—";
  const date = new Date(ts);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

function mapFuelVehicleStatusResponse(raw) {
  const items = raw?.items;
  if (!Array.isArray(items)) return null;

  const rows = items.map((v) => {
    const status = STATUS_TITLE_CASE[v.status] || "Offline";
    const noSensor = !v.sensorOk || v.currentFuelL == null;
    const tankCapacity = v.tankCapacityL;
    const currentFuelL = noSensor ? null : Number(v.currentFuelL);
    const fuelPct =
      tankCapacity && currentFuelL != null
        ? Math.min(100, Math.max(0, (currentFuelL / tankCapacity) * 100))
        : null; // null => don't render a bar


    return {
      id:v.vehicleId,
      vehicleNo: v.regNo,
      subtitle: v.vehicleType || "",
      site: v.site || "",
      driver: v.driverName ?? "NA",
      status,
      tankCapacity,
      currentFuelL,                 // raw number, for the bar / calcs
      currentFuel: noSensor ? "Sensor Disconnect" : `${currentFuelL.toFixed()} L`, // display string, unchanged
      fuelPct,                      // 0–100 or null
      currentFuelColor: status === "Idle" ? "#d97706" : undefined,
      running: `${Number(v.runningKmpl ?? 0).toFixed(2)} (—)`,

      runningDistance: !v.fmsInstalled
        ? "FMS not installed"
        : v.distanceKm == null
          ? "—"
          : {
            startKm: v.startKm != null ? Number(v.startKm).toFixed(2) : "—",
            endKm: v.endKm != null ? Number(v.endKm).toFixed(2) : "—",
            distanceKm: `${Number(v.distanceKm).toFixed(2)} km`,
            engineHours: formatEngineHours(v.engineHoursMs),
            startFuel: v.startFuelL != null ? `${Number(v.startFuelL).toFixed(2)} L` : "—",
            endFuel: v.endFuelL != null ? `${Number(v.endFuelL).toFixed(2)} L` : "—",
          },

      consumption: !v.fmsInstalled
        ? "FMS not installed"
        : v.expectedL == null
          ? "no trip yet"
          : {
            expected: `${Number(v.expectedL).toFixed(2)} L`,
            actual: `${Number(v.actualL ?? 0).toFixed(2)} L`,
            dev: `${Number(v.deviationL ?? 0).toFixed(2)} L`,
            devDir: Number(v.deviationL ?? 0) < 0 ? "down" : "up",
            expectedKmpl: v.expectedKmpl != null ? Number(v.expectedKmpl).toFixed(2) : "—",
            actualKmpl: v.runningKmpl != null ? Number(v.runningKmpl).toFixed(2) : "—",
          },

      droppage: !v.fmsInstalled
        ? "FMS not installed"
        : v.dropConfL == null
          ? "—"
          : {
            confirmed: `${Number(v.dropConfL).toFixed(2)} L`,
            unchecked: `${Number(v.dropUnchkL ?? 0).toFixed(2)} L`,
          },
      fill: v.fmsInstalled ? `${Number(v.fillL ?? 0).toFixed(2)} L` : "—",

      lastUpdated: formatLastUpdated(v.lastUpdateTs),

      disabled: !v.fmsInstalled,
    };
  });

  return {
    vehicleStatusList: rows,
    _nextCursor: raw.nextCursor ?? null,
  };
}


function formatDriverDuration(days) {
  if (days == null) return "—";
  return `${days} Day${days === 1 ? "" : "s"}`;
}

function mapSecureVehiclesResponse(raw) {
  if (!Array.isArray(raw)) return null;
  return {
    operationalIntegrity: raw.map((v) => ({
      id: String(v.vehicleId),
      vehicleNo: v.regNo ?? `Vehicle #${v.vehicleId}`,
      subtitle: [
        VEHICLE_TYPE_LABELS[v.vehicleType] ?? v.vehicleType ?? null,
        v.site,
      ].filter(Boolean).join(" • ") || "—",
      totalDistance: `${Number(v.totalDistanceKm ?? 0).toFixed(1)} km`,
      fuelConsumed: `${Number(v.fuelConsumedL ?? 0).toFixed(1)} L`,
      efficiency: v.efficiencyKmpl != null
        ? `${Number(v.efficiencyKmpl).toFixed(2)} km/L`
        : "—",
      drivers: (v.drivers || []).map((d) => ({
        name: d.driverName ?? "NA",
        duration: formatDriverDuration(d.durationDays),
      })),
    })),
  };
}

// Builds a { [vehicleId]: { vehicleNo, type } } map from your vehicle master list.
// Cache this if called often — hitting the full vehicle list per dashboard refresh is wasteful.
let _vehicleLookupCache = null;
async function getVehicleLookupMap() {
  if (_vehicleLookupCache) return _vehicleLookupCache;
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleList}`;
    const response = await userService.get(apiEndPoint);
    if (response && response.status === 200 && Array.isArray(response.data)) {
      _vehicleLookupCache = Object.fromEntries(
        response.data.map((v) => [v.id, { vehicleNo: v.vehicleNo, type: v.vehicleType }])
      );
      return _vehicleLookupCache;
    }
  } catch (err) {
    console.log("vehicle lookup fetch failed", err);
  }
  return {};
}

const VEHICLE_TYPE_LABELS = {
  // TODO: fill in against your real vehicleType codes — "1" is a guess.
  "1": "TIPPER",
  "2": "TRUCK",
};

function formatDuration(days) {
  if (days == null) return "—";
  return `${days} Day${days === 1 ? "" : "s"}`;
}

function mapTopDroppageResponse(raw, vehicleMap) {
  if (!Array.isArray(raw)) return null;
  return {
    topDroppageVehicles: raw.map((v) => {
      const lookup = vehicleMap?.[v.vehicleId];
      return {
        id: String(v.vehicleId),
        vehicleNo: lookup?.vehicleNo ?? `Vehicle #${v.vehicleId}`, // fallback if lookup misses
        subtitle: [
          VEHICLE_TYPE_LABELS[v.vehicleType] ?? lookup?.type ?? null,
          v.site,
        ].filter(Boolean).join(" • ") || "—",
        events: v.events ?? 0,
        fuelDropped: v.fuelDroppedL ?? 0,
        estimatedLoss: v.estimatedLoss ?? 0,
        drivers: (v.drivers || []).map((d) => ({
          name: d.driverName ?? "NA",
          duration: formatDuration(d.durationDays),
          events: d.events,
          fuelDropped: d.fuelDroppedL,
          estimatedLoss: d.estimatedLoss,
        })),
      };
    }),
    // overBenchmarkCount is not returned by this endpoint — omit it here
    // so the component's `{ ...DEFAULT_DATA, ...data }` spread falls back
    // to the static sample count instead of showing undefined.
  };
}
